export const navbarUserSupportFormShow = (type, isOpen) => ({type, isOpen});

export const navbarColorSet = (type, newColor = null) => ({type, newColor});
